/**
 * Heuristik: Mobile/iOS/iPad oder schmale Viewports.
 * Steuert eingebettete PDF-Vorschau im FilePreviewModal (iframe vs. Fallback-Panel).
 */
export function preferPdfExportActionSheet() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  const ua = String(navigator.userAgent || "").toLowerCase();
  const isIOSPhoneOrPod = /iphone|ipod/.test(ua);
  const isIPadLike = /\bipad\b/.test(ua) || (navigator.platform === "MacIntel" && Number(navigator.maxTouchPoints || 0) > 1);
  const narrow = window.matchMedia?.("(max-width: 767px)")?.matches ?? false;
  return Boolean(isIOSPhoneOrPod || isIPadLike || narrow);
}
